import { render, staticRenderFns } from "./orderInfo.vue?vue&type=template&id=93fff8f4&scoped=true"
import script from "./orderInfo.vue?vue&type=script&lang=js"
export * from "./orderInfo.vue?vue&type=script&lang=js"
import style0 from "./orderInfo.vue?vue&type=style&index=0&id=93fff8f4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93fff8f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('93fff8f4')) {
      api.createRecord('93fff8f4', component.options)
    } else {
      api.reload('93fff8f4', component.options)
    }
    module.hot.accept("./orderInfo.vue?vue&type=template&id=93fff8f4&scoped=true", function () {
      api.rerender('93fff8f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/platformManage/components/orderInfo.vue"
export default component.exports